import React from 'react';
import IconProps from 'shared/components/icons/types';
import { useTheme } from 'styled-components';
import {
  Status,
  StatusTrackerIconContainer,
  StatusTrackerItemDetails,
  StatusTrackerItemWrapper,
  StatusTrackerLabel,
  StatusTrackerSublabel,
  VerticalLine,
} from './OnboardingNav.styles';

export function StatusTrackerItem({
  label,
  detail,
  status,
  isSubtask = false,
  Icon,
  margin,
  showLine = true,
  showLineCompleted,
  onClick,
  disabled = false,
}: {
  label: string;
  detail?: string;
  status: Status;
  isSubtask?: boolean;
  margin?: string;
  Icon: React.FC<IconProps>;
  showLine?: boolean;
  showLineCompleted: boolean;
  onClick: () => void;
  disabled: boolean;
}) {
  const theme = useTheme();

  const getIconColor = () => {
    if (isSubtask) {
      if (status === Status.COMPLETED) return theme.colors.textInverseWhite;
      return status === Status.INCOMPLETE
        ? theme.colors.backgroundAccentGreyStrongestGrey90
        : theme.colors.backgroundSystemCtaSecondary2100;
    }
    return status === Status.INCOMPLETE
      ? theme.colors.iconSystemIconDisabledGrey50
      : theme.colors.iconIconPrimaryPressedSecondary2100;
  };
  return (
    <StatusTrackerItemWrapper
      $isSubtask={isSubtask}
      $margin={margin}
      onClick={onClick}
      $disabled={disabled}
    >
      <div>
        <StatusTrackerIconContainer $status={status} $isSubtask={isSubtask}>
          <Icon color={getIconColor()} />
        </StatusTrackerIconContainer>
        <VerticalLine
          $showLine={showLine}
          $showCompleted={showLineCompleted}
          $isSubtask={isSubtask}
        />
      </div>
      <StatusTrackerItemDetails aria-disabled={disabled} disabled={disabled}>
        <StatusTrackerLabel as="h3" $status={status} $isSubtask={isSubtask}>
          {label}
        </StatusTrackerLabel>
        {detail && (
          <StatusTrackerSublabel as="sub" $isSubtask={isSubtask}>
            {detail}
          </StatusTrackerSublabel>
        )}
      </StatusTrackerItemDetails>
    </StatusTrackerItemWrapper>
  );
}

export default StatusTrackerItem;
